import React from 'react';
import PropTypes from 'prop-types';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import Toolbar from './Toolbar';
import Header from './Header';
import EventCell from './EventCell';
import { colors } from 'kangarootime-ui';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './overrides.css';

const Calendar = ({ events, birthdays, onMonthChange, fetchingEvents, onEventSelect, onDateSelect }) => {
  return (
    <div style={{ height: '100%', padding: 8 }}>
      <BigCalendar
        selectable
        localizer={BigCalendar.momentLocalizer(moment)}
        events={[...events, ...birthdays]}
        titleAccessor='title'
        startAccessor='start'
        endAccessor='end'
        allDayAccessor='allDay'
        defaultView='month'
        views={['month', 'week', 'day']}
        components={{
          toolbar: toolbar => <Toolbar toolbar={toolbar} onMonthChange={onMonthChange} fetchingEvents={fetchingEvents} />,
          header: Header,
          eventWrapper: EventCell
        }}
        eventPropGetter={event => ({
          style: {
            backgroundColor: event.type === 'birthday' ? colors.brand_1 : colors.steelBlue,
            borderColor: event.type === 'birthday' ? colors.brand_1 : colors.steelBlue,
            color: '#FFFFFF',
            fontFamily: 'proxima-soft, sans-seriff',
            marginLeft: 4,
            marginRight: 4,
            cursor: event.type === 'birthday' && 'initial'
          } })
        }
        onSelectEvent={onEventSelect}
        onSelectSlot={onDateSelect}
        style={{ height: '90%' }}
      />
    </div>
  );
};

Calendar.propTypes = {
  events: PropTypes.array,
  birthdays: PropTypes.array,
  onMonthChange: PropTypes.func,
  fetchingEvents: PropTypes.bool,
  onEventSelect: PropTypes.func,
  onDateSelect: PropTypes.func
};

export default Calendar;
